import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface OperationPlanPanelState {
  isOpen: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
}

export const useOperationPlanPanel = create<OperationPlanPanelState>()(
  persist(
    (set) => ({
      isOpen: true,
      toggle: () => set((s) => ({ isOpen: !s.isOpen })),
      setOpen: (open) => set({ isOpen: open }),
    }),
    {
      name: 'warplan.operation-plan-panel',
      partialize: (s) => ({ isOpen: s.isOpen }),
    },
  ),
);
